import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'

export const createSectionStepsProjection = (localeId: LocaleId) => {
  return groq`{
      _key,
      _type,
      ${coalesceLocaleField('title', localeId)},
      spacing,
      topBorder,
      steps[]{
        _key,
        ${coalesceLocaleField('title', localeId)},
        ${coalesceLocaleField('content', localeId)},
        }
      }
  `
}
